import { observes } from "@ember-decorators/object"
import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import * as Sentry from "@sentry/browser"
import ObjectId from "@shared/util/object-id-gen"
import standardsSearchAddPaneAction from "cc-frontend/lib/actions/app/STANDARDS_SEARCH_ADD_PANE"
import standardsSearchRemoveSetAction from "cc-frontend/lib/actions/app/STANDARDS_SEARCH_REMOVE_SET"
import standardsSearchSelectSetAction from "cc-frontend/lib/actions/app/STANDARDS_SEARCH_SELECT_SET"
import _ from "lodash"

export default class Search extends Component {
  // Services
  @service dispatcher
  @service algolia
  @service notifier

  // Args
  jurisdictions
  jurisdictionsIsFulfilled
  standardSetIds
  setStandardSetIds
  toggleStandard
  showStandardCoverage
  selectedStandardIds
  standardsCoverage

  // Props
  searchErrorCount = 0
  hasSelectedSet = false
  results = null
  query = null

  @computed("standardSetIds.[]", "hasSelectedSet")
  get isSearchVisible() {
    return (
      this.get("hasSelectedSet") ||
      _.chain(this.standardSetIds)
        .filter(function (s) {
          return !_.includes(s, "blank")
        })
        .value().length > 0
    )
  }

  @observes("query")
  watchQuery() {
    scheduleOnce("afterRender", this, _.throttle(this.searchAlgolia, 100))
  }

  searchAlgolia() {
    let query = _.truncate(this.query, { length: 511 })

    if (query === "" || isNone(query)) {
      this.set("results", null)
      return
    }
    this.get("algolia.index")
      .search(query, {
        attributesToRetrieve: "id",
        tagFilters: [this.standardSetIds],
        hitsPerPage: 1000,
      })
      .then((data) => {
        this.searchErrorCount = 0
        return this.set("results", _.map(data.hits, "id"))
      })
      .catch((err) => {
        this.searchErrorCount++
        if (this.searchErrorCount > 10) {
          console.error(err)
          Sentry.withScope((scope) => {
            scope.setLevel(Sentry.Severity.Error)
            scope.setExtra("error", err)
            Sentry.captureMessage("Algolia search error")
          })
          this.notifier.warning("", {
            notificationId: this.query,
            title: `We're having some trouble searching right now.`,
            message: "Please try again later.",
            duration: 5000,
            type: "is-processing",
          })
        }
      })
  }

  @action
  selectSet(id, oldId) {
    var index = this.standardSetIds.indexOf(oldId)
    this.standardSetIds.replace(index, 1, [id])
    this.setStandardSetIds(this.standardSetIds)
    this.set("hasSelectedSet", true)
    this.dispatcher.dispatchPreparedAction(standardsSearchSelectSetAction({ standardSetId: id }))
  }

  @action
  removeSet(id) {
    if (this.standardSetIds.length == 1) return
    this.standardSetIds.removeObject(id)
    this.setStandardSetIds(this.standardSetIds)
    this.dispatcher.dispatchPreparedAction(standardsSearchRemoveSetAction({}))
  }

  @action
  addPane() {
    this.standardSetIds.pushObject("blank" + ObjectId.create())
    this.dispatcher.dispatchPreparedAction(standardsSearchAddPaneAction({}))
  }

  @action
  onToggleStandard(standard) {
    this.toggleStandard(standard)
  }
}
